import { inject } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { AppConstants } from '../app-constants';
import { CustomParser } from '../translate-parser/translate-parser';
import { MissingTranslationService } from './missing-translation.service';

export class MissingTranslation implements MissingTranslationHandler {
  private readonly missingTranslationService = inject(MissingTranslationService);

  handle(params: MissingTranslationHandlerParams): string {
    const { key, interpolateParams } = params;

    let defaultTranslations = {};

    const activeLanguage = this.missingTranslationService.getLanguage();
    const supportedLanguages = this.missingTranslationService.getSupportedLanguages() || [];
    const useActiveLanguage = supportedLanguages.indexOf(activeLanguage) !== -1;

    try {
      defaultTranslations = useActiveLanguage
        ? require('../../../assets/i18n/' + activeLanguage + '.json')
        : require('../../../assets/i18n/en.json');
    } catch (error) {
      console.log(error);
    }

    if (!defaultTranslations[key]) {
      defaultTranslations[key] = AppConstants.MISSING_TRANSLATION;
    }

    return interpolateParams
      ? CustomParser.translationWithInterpolation(defaultTranslations[key], interpolateParams)
      : defaultTranslations[key];
  }
}
